import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

/**
 * Button — wraps the kit's .btn class with CVA variants.
 * Matches the DS's five surfaces : default (neutral), primary (accent),
 * ghost (transparent), danger (red), and two sizes.
 */
const button = cva('btn', {
  variants: {
    variant: {
      default: '',
      primary: 'primary',
      ghost:   'ghost',
      danger:  'danger',
    },
    size: {
      sm: 'sm',
      md: '',
      lg: 'lg',
    },
  },
  defaultVariants: { variant: 'default', size: 'md' },
});

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof button> {
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
}

export function Button({
  variant, size, className, leftIcon, rightIcon, children, ...rest
}: ButtonProps) {
  return (
    <button className={cn(button({ variant, size }), className)} {...rest}>
      {leftIcon}
      {children}
      {rightIcon}
    </button>
  );
}
